/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { FormattedMessage } from '@atlassian/jira-intl';
import { messages } from './messages';

const linkStyles = css({
	textDecoration: 'underline',
});

export const Subheader = () => (
	<Box xcss={containerStyles}>
		<FormattedMessage
			{...messages.pageDescription}
			values={{
				configureIssueLinkTypesLink: (
					<a href="/jira/admin/ViewLinkTypes!default.jspa" css={linkStyles}>
						<FormattedMessage
							id="portfolio-dependency-settings.configure-issue-link-types-text"
							defaultMessage="issue link types"
						/>
					</a>
				),
			}}
		/>
	</Box>
);

const containerStyles = xcss({
	marginTop: 'space.050',
});
